import { ContentItem } from 'kentico-cloud-delivery';
import get from 'lodash/get';

export default class Country extends ContentItem {
  constructor() {
    super({
      propertyResolver: fieldName => `_${fieldName}`
    });
  }

  get name() {
    return get(this, '_nazwa.value', '');
  }

  get iso2() {
    return get(this, '_iso2.value', '');
  }
}



// WEBPACK FOOTER //
// ./src/models/Country.js